const ALLOWED_MAP_HOSTS = ['www.google.com', 'maps.google.com', 'google.com'];

/** Extrae y valida la URL src de un iframe de Google Maps o una URL embed directa. */
export function getMapEmbedSrc(raw) {
  if (raw == null || typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  let candidate = trimmed;
  const iframeSrc = trimmed.match(/<iframe[^>]+src=["']([^"']+)["']/i);
  if (iframeSrc?.[1]) candidate = iframeSrc[1];

  try {
    const url = new URL(candidate);
    if (url.protocol !== 'https:') return null;
    const host = url.hostname.replace(/^www\./, '');
    const allowed = ALLOWED_MAP_HOSTS.some(
      (h) => host === h.replace(/^www\./, '') || host.endsWith('.google.com')
    );
    if (!allowed) return null;
    return url.toString();
  } catch {
    return null;
  }
}
